import { Component } from '@angular/core';
import { PageSlotModule } from '@spartacus/storefront';

@Component({
  selector: 'wc-promo-banners',
  templateUrl: './promo-banners.component.html',
  standalone: true,
  imports: [PageSlotModule]
})
export class PromoBannersComponent {}
